import { connectorDirectory } from "../../lib/connectorDirectory";

const bundledIdentifierByName = new Map<string, string>(
  connectorDirectory.map((c) => [c.name, c.identifier])
);

// Tenant connectors (keyed by their possibly-renamed display name) resolve to
// their exact identifier; the bundled catalog covers connectors referred to by
// their standard name; the name itself is the last resort so ConnectorLogo can
// still fall back to a favicon or letter badge.
export function connectorPillIdentifier(
  name: string,
  tenantIdentifierByName: ReadonlyMap<string, string>
): string {
  return (
    tenantIdentifierByName.get(name) ??
    bundledIdentifierByName.get(name) ??
    name
  );
}
